export const KNOWLEDGE_HUB = 'knowledgeHub';
export const COURSE = 'course';
export const GUIDE = 'guide';
export const LESSON = 'lesson';

// resource type
export const DEMO = 'demo';
